module.exports = __webpack_public_path__ + "static/media/Oct_2025_2.be5fa843.webp";